/**
 * Shared FullCalendar options that keep small calendar widgets legible on
 * mobile. Without `dayMaxEvents`, every event tries to fit into its day cell
 * and they overlap; without a shorter weekday format, "quarta-feira" doesn't
 * fit a narrow mobile column and runs into the next day's header.
 *
 * Spread the result into any <FullCalendar {...fullCalendarMobileDefaults()} />
 * — first consumer: the weekly agenda widget on the manager dashboard.
 */
export function fullCalendarMobileDefaults(options?: {
  maxEventsDesktop?: number
  maxEventsMobile?: number
}) {
  const isMobile =
    typeof window !== 'undefined' && window.matchMedia('(max-width: 767.98px)').matches

  return {
    dayMaxEvents: isMobile ? options?.maxEventsMobile ?? 2 : options?.maxEventsDesktop ?? 3,
    dayHeaderFormat: isMobile ? ({weekday: 'short'} as const) : ({weekday: 'long'} as const),
  }
}
